import DOMPurify from 'dompurify';

interface AnswerInBlanksProps {
  answer: string;
}

const AnswerInBlanks = ({ answer }: AnswerInBlanksProps) => {
  const cleanAnswer = DOMPurify.sanitize(answer, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: []
  });

  const answerText = cleanAnswer
    .split('{{comma}}')
    .map((item) => item.trim())
    .filter(Boolean)
    .join(', ');

  return <p className="h-full whitespace-normal break-words">{answerText}</p>;
};

export default AnswerInBlanks;
